import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import utils from 'Utils';
import Accordion from 'Components/accordion';
import SelectCategoriesInput from 'Components/selectCategoriesInput';
import getCategoriesWithParents from 'Selectors/getCategoriesWithParents';
import * as styles from './selectedCategories.css';

const { groupBy } = utils.array;
const { mapKV } = utils.obj;

const categoryMapFn = (parents, activeParents) => (children, key) => (
  <Accordion
    name={parents[key]}
    visible={activeParents.includes(key)}
    key={key}
    className={styles.accordionTitle}
  >
    <ul className={styles.ul}>
      { children.map(({ key: cKey, name }) => (
        <SelectCategoriesInput
          visible={activeParents.includes(key)}
          key={name + cKey}
          label={name}
          id={cKey}
        />
      )) }
    </ul>
  </Accordion>
);

const SelectCategories = ({
  categories,
  parentCategories,
  activeParents,
}) => (
  <div>
    {
      mapKV(
        groupBy(categories, 'parent'),
        categoryMapFn(parentCategories, activeParents),
        true
      )
    }
  </div>
);

SelectCategories.propTypes = {
  parentCategories: PropTypes.object.isRequired,
  categories: PropTypes.arrayOf(PropTypes.object).isRequired,
  activeParents: PropTypes.arrayOf(PropTypes.string).isRequired,
};

const mapStateToProps = (state) => {
  // Build object of categories and their parents
  const categoriesWithParents = getCategoriesWithParents(state);
  // Get all active categories from router data
  const activeCategories =
    (state.data.selectedCategories || []).map((x) => `${x}`);
  // Map the active categories back to their parents
  const activeParents = categoriesWithParents.categories
    .reduce((acc, curr) =>
      [...acc].concat(
        activeCategories.includes(curr.key) ? [`${curr.parent}`] : []
      ),
    []);
  return { ...categoriesWithParents, activeParents, activeCategories };
};

export default connect(mapStateToProps)(SelectCategories);

// Testing exports
export {
  SelectCategories,
};



// WEBPACK FOOTER //
// ./app/components/selectCategories/index.js